export default "__VITE_ASSET__CeiTDjrD__"